import "./index_module.css";
var index_module_default = { "banner": "banner_f6fea", "modal": "modal_f6fea", "modalTitle": "modalTitle_f6fea", "modalText": "modalText_f6fea", "buttonRow": "buttonRow_f6fea", "m4bButton": "m4bButton_f6fea", "secButton": "secButton_f6fea", "priButton": "priButton_f6fea" };
export {
  index_module_default as default
};
